import {createFileRoute} from '@tanstack/react-router';
import SportPortal from '../../../../sports/SportPortal.tsx';
import {SPORT_AREAS} from '../../../../sports/sportAreas.ts';

export const Route = createFileRoute('/_app/esports/tournaments/')({
    component: RouteComponent,
})

function RouteComponent() {
    return <SportPortal sport={SPORT_AREAS.esports} section="tournaments"/>
}
